<template>
  <div>
    <v-container class="pt-0 pb-5" v-if="commande.id && commande.statut != 'PAID' && !has_expired">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> Récapitulatif de ma commande</h4>
            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <div v-if="expiration">Ce lien de paiement expirera le
                  {{ $moment(expiration).format("DD/MM/YYYY HH:mm:ss") }}</div>
                <div class="d-flex flex-column align-start justify-stretch rounded bg-dark pa-4 mt-2">
                  <div class="d-flex justify-space-between w-100">
                    <div>Nombre d'articles</div>
                    <div>
                      {{ commande.nb_articles }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between w-100" v-if="commande.exclude_taxe == '0'">
                    <div>Sous Total</div>
                    <div v-if="parseFloat(commande.prix) > 0">{{ commande.prix }}€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100" v-if="commande.exclude_taxe == '0'">
                    <div>Frais de gestion</div>
                    <div>{{ commande.taxe }}€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Total à payer</div>
                    <div>{{ commande.prix_total }}€</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" offset-md="3">
                <AfterAccessCheckout :commande="commande"></AfterAccessCheckout>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-5" v-else-if="commande.id && commande.statut == 'PAID'">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-alert>Accès refusé. Cette commande a déjà été payée.</v-alert>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-5" v-else>
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-alert>Accès refusé. Ce lien a expiré.</v-alert>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Commande from "@/classes/Commande/Commande.class.js";
import AfterAccessCheckout from "@/components/Checkout/Access_Resend_Payment_Checkout.vue";
export default {
  components: {
    AfterAccessCheckout,
  },
  data() {
    return {
      crypted_uuid: "",
      commande: {},
      token: "",
      expiration: null,

    };
  },
  computed: {
    has_expired() {
      if (!this.commande.id) {
        return false;
      }
      if (!this.expiration) {
        return false;
      }
      const now = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      if (this.$moment(this.expiration).isBefore(now)) {
        return true;
      }
      return false;

    }
  },
  methods: {

    async get_commande() {
      this.commande = new Commande();
      await this.commande.get_by_crypted_uuid(this.token);
      if (!this.commande.id) {
        this.$router.push({ name: "Home" });
      }
    },
    get_token() {
      let token = this.$route.query.c;
      if (!token) {
        this.$router.push({ name: "Home" });
      }
      if (token.includes("%7C") || token.includes("|")) {
        const split = token.split("|");
        this.token = split[0];
        const unixtime = split[1];
        this.expiration = this.$moment(unixtime * 1000).format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.token = token;
        this.expiration = null;
      }
    }
  },
  async created() {
    this.get_token();
    await this.get_commande();
  },
};
</script>

<style lang="scss" scoped></style>